module.exports = __webpack_public_path__ + "../resources/images/captureEmpty-b18c2fb88552e787c623893628f281db.svg";